var es = require('elasticsearch');

var client = null;
var elasticIndex = null;
var elasticType = null;
var scrollId = null;
var elasticList = [];
var elasticTotal = 0;
const NumberCheck = (val) => {
	if(Number.isNaN(val)) {
		return false;
	}
	return true;
}
const makeElasticBody = (filterSet) => {
	let body = {
		query: {
			bool: {
				must: [],
			}
		}
	};
	let filterArr = Object.values(filterSet.filter);
	filterArr.forEach(filter => {
		let query = {};
		if(filter.hasOwnProperty('value')) {
			if(NumberCheck(filter.value)) {
				filter.value = Number(filter.value);
			}
			query.match = {};
			query.match[filter.key] = filter.value;
		}else if(filter.hasOwnProperty('start') || filter.hasOwnProperty('end')) {
			if(NumberCheck(filter.start)) {
				filter.start = Number(filter.start);
			}
			if(NumberCheck(filter.end)) {
				filter.end = Number(filter.end);
			}
			query.range = {};
			query.range[filter.key] = {};
			if(filter.hasOwnProperty('start')) {
				query.range[filter.key].gte = filter.start;
			}
			if(filter.hasOwnProperty('end')) {
				query.range[filter.key].lte = filter.end;
			}
		}else if(filter.hasOwnProperty('query')) {
			query.simple_query_string = {
				query: `("${filter.query}")`,
				'fields': [filter.key]
			}
		}
		body.query.bool.must.push(query)
	});
	if(filterSet.sort.hasOwnProperty('key') && filterSet.sort.hasOwnProperty('order')) {
		body.sort = {};
		body.sort[filterSet.sort.key] = filterSet.sort.order;
	}
	body.from = (Number(filterSet.page.page) - 1) * Number(filterSet.page.size);
	body.size = Number(filterSet.page.size);
	return body;
}

export const initElastic = function(url=null, index=null, type=null) {
	if(!url || !index || !type) {
		return false;
	}
	elasticIndex = index;
	elasticType = type;
	client = new es.Client({
		host: url,
	});
	return true;
}

export const clearScroll = function () {
	if(client && !scrollId) {
		client.clearScroll({
			scroll_id: scrollId,
		})
	}
}

const getElasticCount = (body) => {
	let countBody = {
		query: body.query,
	}
	let subCountObj = {
		index: elasticIndex,
		type: elasticType,
		body: countBody,
	}
	return client.count(subCountObj).then(res => {
		return res.count
	})
};
const getElasticSearch = (body) => {
	let subSearchObj = {
		index: elasticIndex,
		type: elasticType,
		body: body,
	}
	let list = [];
	return client.search(subSearchObj).then((res) => {
		res.hits.hits.forEach((data, index) => {
			list.push(data._source);
			if(index === res.hits.hits.length - 1) {
				scrollId = data._id;
			}
		})
		return list;
	})
};

const reformList = (body) => {
	let list = [];
	let beforeList = [];
	if(body.from+body.size < elasticList.length-1){
		beforeList = elasticList.slice(body.from, body.from+body.size);
	}else{
		beforeList = elasticList.slice(body.from, elasticList.length);
	}
	beforeList.forEach(data => {
		// console.log(data);
		list.push(data._source);
	})
	if(elasticList.length === elasticTotal) {
		clearScroll();
	}
	return list;
}

const getElasticScrollId = async (body) => {
	return client.search({
		index: elasticIndex,
		type: elasticType,
		scroll: '1d',
		size: 500,
		body: {
			query: body.query,
			sort: body.sort,
			// from: 10000-body.size-1,
			// size: body.size,
		},
	}).then(res => {
		scrollId = res._scroll_id;
		elasticList = res.hits.hits;
		elasticTotal = res.hits.total.value;
		if(body.from > elasticList.length) {
			return getElasticScroll(body)
		}else{
			return reformList(body);
		}
		// return res.hits.hits;
	})
}

const getElasticScroll = async (body) => {
	let subScrollhObj = {
		scroll_id: scrollId,
		scroll: '1m'
	}
	return client.scroll(subScrollhObj).then(res => {
		elasticList = elasticList.concat(res.hits.hits);
		if(body.from > elasticList.length) {
			return getElasticScroll(body);
		}else{
			return reformList(body)
		}
	}, (err) => {
		return [];
	})
	// return [];
}

export const getElasticData = async function(filter, type='search') {
	let list = [];
	let body = makeElasticBody(filter);
	if(body.from < 0) {
		return {
			page: {
				total: elasticTotal
			},
			list: [],
		}
	}
	console.log(body.from > elasticList.length && scrollId != null);
	if(body.from === 0 || !scrollId) {
		// elasticTotal = await getElasticCount(body);
		if(scrollId) {
			await clearScroll();
		}
		list = await getElasticScrollId(body);
		return {
			page: {
				total: elasticTotal
			},
			list: list,
		}
	}else if(body.from > elasticList.length && scrollId != null) {
		list = await getElasticScroll(body);
		return {
			page: {
				total: elasticTotal
			},
			list: list,
		}
	}else{
		list  = await reformList(body);
		return {
			page: {
				total: elasticTotal
			},
			list: list,
		}
	}
	// return {
	// 	page: {
	// 		total: total
	// 	},
	// 	list: list,
	// }
}
